const DealDucksIcon = (props) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    width={props.size}
    height={props.size}
    {...props}
    xmlSpace="preserve"
  >
    <style type="text/css">
      {`
      .col1 { fill:rgb(132, 70, 255); }
      .col2 { fill:rgb(19, 7, 41); }
    `}
    </style>

    <g>
      <g>
        <circle className="col1" cx="16" cy="16" r="16" />
      </g>
      <g>
        <path
          className="col2"
          d="M16,28.6C9.1,28.6,3.4,22.9,3.4,16S9.1,3.4,16,3.4S28.6,9,28.6,16C28.6,22.9,22.9,28.6,16,28.6z M16,4.5
			C9.6,4.5,4.5,9.6,4.5,16S9.6,27.5,16,27.5S27.5,22.4,27.5,16S22.4,4.5,16,4.5z"
        />
      </g>
      <g>
        <path
          className="col2"
          d="M24.4,16.6v-1.4H23v-1.3h-2.5v-1.6h-1.3v1.6h-3.3v9.8h3.3v1.5h1.3v-1.5H23v-1.4h1.4v-1.4h1.4v-4.2H24.4z
			 M18.4,22.2v-7h0.9v7H18.4z M23,20.8h-1.4v1.4h-1v-7h1v1.4H23V20.8z"
        />
      </g>
      <g>
        <path
          className="col2"
          d="M16.1,12.2v-1.4h-1.4V9.4h-2.5V7.7h-1.3v1.6H7.6v9.8h3.3v1.5h1.3v-1.5h2.5v-1.4h1.4v-1.4h1.4v-4.2H16.1z
			 M10.1,17.8v-7H11v7H10.1z M14.6,16.4h-1.4v1.4h-1v-7h1v1.4h1.4V16.4z"
        />
      </g>
    </g>
  </svg>
);

export default DealDucksIcon;
